export function isSameDomain(data, widgetName) {
  const clientPath = SITEBASEURL;
  $(`#${widgetName}`)
    .find('.card-widget-item')
    .each(function (x) {
      const { URL } = data.items[x];
      const $cardItem = $(this);

      if (URL) {
        const isSame = URL.startsWith(clientPath);
        if (!isSame) {
          $cardItem.attr('target', '_blank');
        } else {
          $cardItem.removeAttr('target');
        }
      }
    });
}
